export enum CurrencyCode {
  USD = 'USD',
  EUR = 'EUR',
}
